module.exports = __webpack_public_path__ + "img/logo-ds.6186282f.png";